/**
 * Yanchuan Theme - Interactive Behaviors
 * Handles: header scroll, mobile menu, fade-in animations,
 * product catalog tabs, products page filtering/sorting
 */
(function () {
  "use strict";

  // ============================================================
  // 1. Header Scroll Effect
  // ============================================================
  function initHeaderScroll() {
    var header = document.querySelector(".header-yanchuan");
    if (!header) return;

    function onScroll() {
      if (window.scrollY > 20) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll(); // initial state
  }

  // ============================================================
  // 2. Mobile Menu Toggle
  // ============================================================
  function initMobileMenu() {
    var toggle = document.querySelector(".header-yanchuan__mobile-toggle");
    var menu = document.querySelector(".header-yanchuan__mobile-menu");
    if (!toggle || !menu) return;

    var iconOpen = toggle.querySelector(".icon-open");
    var iconClose = toggle.querySelector(".icon-close");

    toggle.addEventListener("click", function () {
      var isOpen = menu.classList.contains("open");
      if (isOpen) {
        menu.classList.remove("open");
        if (iconOpen) iconOpen.style.display = "";
        if (iconClose) iconClose.style.display = "none";
        toggle.setAttribute("aria-expanded", "false");
      } else {
        menu.classList.add("open");
        if (iconOpen) iconOpen.style.display = "none";
        if (iconClose) iconClose.style.display = "";
        toggle.setAttribute("aria-expanded", "true");
      }
    });

    // Close menu when clicking a link inside
    var menuLinks = menu.querySelectorAll("a");
    for (var i = 0; i < menuLinks.length; i++) {
      menuLinks[i].addEventListener("click", function () {
        menu.classList.remove("open");
        if (iconOpen) iconOpen.style.display = "";
        if (iconClose) iconClose.style.display = "none";
        toggle.setAttribute("aria-expanded", "false");
      });
    }
  }

  // ============================================================
  // 3. Fade-In on Scroll (IntersectionObserver)
  // ============================================================
  function initFadeInObserver(container) {
    container = container || document;
    var elements = container.querySelectorAll(".fade-in-observer");
    if (!elements.length) return;

    // In design mode (theme editor), make everything visible immediately
    if (window.Shopify && window.Shopify.designMode) {
      for (var i = 0; i < elements.length; i++) {
        elements[i].classList.add("visible");
      }
      return;
    }

    if (!("IntersectionObserver" in window)) {
      // Fallback: make all visible immediately
      for (var i = 0; i < elements.length; i++) {
        elements[i].classList.add("visible");
      }
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add("visible");
            observer.unobserve(entries[i].target);
          }
        }
      },
      { threshold: 0.1 },
    );

    for (var j = 0; j < elements.length; j++) {
      observer.observe(elements[j]);
    }
  }

  // Make fade-in elements visible in a section (for theme editor re-renders)
  function makeSectionVisible(sectionId) {
    var sectionEl = document.getElementById("shopify-section-" + sectionId);
    if (!sectionEl) return;
    var fadeEls = sectionEl.querySelectorAll(".fade-in-observer");
    for (var i = 0; i < fadeEls.length; i++) {
      fadeEls[i].classList.add("visible");
    }
  }

  // Listen for Shopify section events in the theme editor
  document.addEventListener("shopify:section:load", function (event) {
    makeSectionVisible(event.detail.sectionId);
    initProductCatalogTabs();
    initProductsPage();
    initProductInfo();
    initQuantitySelectors();
    initCartRemoveButtons();
  });
  document.addEventListener("shopify:section:select", function (event) {
    makeSectionVisible(event.detail.sectionId);
  });

  // ============================================================
  // 4. Product Catalog Tabs
  // ============================================================
  function initProductCatalogTabs() {
    var tabContainer = document.querySelector(".product-catalog__tabs");
    if (!tabContainer) return;

    var tabs = tabContainer.querySelectorAll(".product-catalog__tab");
    var grid = document.querySelector(".product-catalog__grid");
    if (!grid) return;

    var products = grid.querySelectorAll("[data-tab]");

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        tabs.forEach(function (t) {
          t.classList.remove("active");
        });
        tab.classList.add("active");

        var tabId = tab.getAttribute("data-tab");

        products.forEach(function (product) {
          product.style.display =
            product.getAttribute("data-tab") === tabId ? "" : "none";
        });
      });
    });
  }

  // ============================================================
  // 5. Products Page - Category Filtering & Sorting
  // ============================================================
  function initProductsPage() {
    var categoryButtons = document.querySelectorAll(
      ".products-page-sidebar__category-btn",
    );
    if (!categoryButtons.length) return;

    var sortSelect = document.querySelector(
      ".products-page-sidebar__sort-select",
    );
    var grid = document.querySelector(".products-page-grid");
    var countNumEl = document.getElementById("products-page-count-num");
    var descriptionEl = document.querySelector(".products-page-hero__desc");
    var titleEl = document.querySelector(".products-page-hero__title");

    if (!grid) return;

    var allCards = grid.querySelectorAll(".product-card");

    var activeBtn = document.querySelector(
      ".products-page-sidebar__category-btn.active",
    );
    var currentCategory = activeBtn
      ? activeBtn.getAttribute("data-category")
      : categoryButtons[0].getAttribute("data-category");

    function sortCards(cards, sortBy) {
      cards.sort(function (a, b) {
        var titleA = (a.getAttribute("data-title") || "").toLowerCase();
        var titleB = (b.getAttribute("data-title") || "").toLowerCase();
        var priceA = parseFloat(a.getAttribute("data-price") || "0");
        var priceB = parseFloat(b.getAttribute("data-price") || "0");

        switch (sortBy) {
          case "name-asc":
            return titleA.localeCompare(titleB);
          case "name-desc":
            return titleB.localeCompare(titleA);
          case "price-asc":
            return priceA - priceB;
          case "price-desc":
            return priceB - priceA;
          default:
            return 0;
        }
      });
    }

    function filterAndSort() {
      var categoryCards = [];

      allCards.forEach(function (card) {
        if (card.getAttribute("data-category") === currentCategory) {
          categoryCards.push(card);
        }
      });

      // Hide all first, then show matching
      allCards.forEach(function (card) {
        card.style.display = "none";
      });

      // Sort
      var sortValue = sortSelect ? sortSelect.value : "default";
      sortCards(categoryCards, sortValue);

      // Show & re-append sorted cards
      categoryCards.forEach(function (card) {
        card.style.display = "";
        grid.appendChild(card);
      });

      // Update count
      if (countNumEl) {
        countNumEl.textContent = categoryCards.length;
      }

      // Update hero text from active button
      var activeCategoryBtn = document.querySelector(
        ".products-page-sidebar__category-btn.active",
      );
      if (activeCategoryBtn) {
        var catTitle = activeCategoryBtn.getAttribute("data-category-title");
        var catDesc = activeCategoryBtn.getAttribute("data-category-desc");
        if (titleEl && catTitle) titleEl.textContent = catTitle;
        if (descriptionEl && catDesc) descriptionEl.textContent = catDesc;
      }

      // Show empty state if nothing visible
      var emptyEl = grid.querySelector(".products-page-empty");
      if (categoryCards.length === 0) {
        if (!emptyEl) {
          emptyEl = document.createElement("p");
          emptyEl.className = "products-page-empty";
          emptyEl.textContent = "No products found";
          grid.appendChild(emptyEl);
        }
        emptyEl.style.display = "";
      } else if (emptyEl) {
        emptyEl.style.display = "none";
      }
    }

    // Category button clicks
    categoryButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        categoryButtons.forEach(function (b) {
          b.classList.remove("active");
        });
        btn.classList.add("active");
        currentCategory = btn.getAttribute("data-category");
        if (sortSelect) sortSelect.value = "default";
        filterAndSort();
      });
    });

    // Sort change
    if (sortSelect) {
      sortSelect.addEventListener("change", filterAndSort);
    }

    // Initial filter
    filterAndSort();
  }

  // ============================================================
  // 6. Product Image Error Fallback
  // ============================================================
  function initImageFallback() {
    document
      .querySelectorAll(".product-card__image-wrapper img")
      .forEach(function (img) {
        img.addEventListener("error", function () {
          var wrapper = img.closest(".product-card__image-wrapper");
          if (wrapper) {
            var placeholder = document.createElement("div");
            placeholder.className = "product-card__image-placeholder";
            placeholder.innerHTML =
              '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="3" rx="2" ry="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/></svg>';
            wrapper.innerHTML = "";
            wrapper.appendChild(placeholder);
          }
        });
      });
  }

  // ============================================================
  // 7. Anchor Navigation for Home Page Hash Links
  // ============================================================
  function initAnchorNav() {
    // Handle hash links that scroll to sections
    // The header height offset
    var headerHeight = 72;

    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener("click", function (e) {
        var href = link.getAttribute("href");
        if (!href || href === "#") return;

        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          var top =
            target.getBoundingClientRect().top +
            window.pageYOffset -
            headerHeight;
          window.scrollTo({ top: top, behavior: "smooth" });
        }
      });
    });
  }

  // ============================================================
  // 8. Active Nav Link Detection
  // ============================================================
  function initActiveNav() {
    var currentPath = window.location.pathname;
    if (currentPath === "/") currentPath = "/";

    document
      .querySelectorAll(".header-yanchuan__nav a")
      .forEach(function (link) {
        var href = link.getAttribute("href");
        if (!href) return;

        // Check if this link matches current page
        var linkPath = href;
        // Remove leading slash for comparison
        if (currentPath === "/" && linkPath === "/") {
          link.classList.add("active");
        } else if (
          linkPath !== "/" &&
          linkPath !== "#" &&
          currentPath.indexOf(linkPath) === 0
        ) {
          link.classList.add("active");
        }
      });
  }

  // ============================================================
  // 7. Product Info Page - Media Gallery & Collapsible Tabs
  // ============================================================
  function initProductInfo() {
    // Media thumbnail switching
    var thumbs = document.querySelectorAll(".product-info__thumb");
    if (!thumbs.length) return;

    var mediaItems = document.querySelectorAll(".product-info__media-item");

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var mediaId = this.getAttribute("data-media-id");
        // Update thumbs
        thumbs.forEach(function (t) {
          t.classList.remove("active");
        });
        this.classList.add("active");
        // Show matching media
        mediaItems.forEach(function (item) {
          item.classList.remove("active");
          if (item.getAttribute("data-media-id") === mediaId) {
            item.classList.add("active");
          }
        });
      });
    });

    // Collapsible tabs
    var toggles = document.querySelectorAll(
      ".product-info__collapsible-toggle",
    );
    toggles.forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        var parent = this.closest(".product-info__collapsible");
        if (parent) {
          parent.classList.toggle("open");
        }
      });
    });
  }

  // ============================================================
  // 8. Quantity Selector Buttons (Product Info + Cart Page)
  // ============================================================
  var _cartQtyBound = false;

  function initQuantitySelectors() {
    // Product Info page quantity (direct listeners since DOM is stable)
    var qtyBtns = document.querySelectorAll(".product-info__qty-btn");
    qtyBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var container = this.closest(".product-info__quantity-selector");
        if (!container) return;
        var input = container.querySelector(".product-info__qty-input");
        if (!input) return;
        var val = parseInt(input.value, 10) || 1;
        var action = this.getAttribute("data-action");
        if (action === "plus") {
          var max = input.getAttribute("max");
          if (max && val >= parseInt(max, 10)) return;
          input.value = val + 1;
        } else if (action === "minus") {
          if (val <= 1) return;
          input.value = val - 1;
        }
        var form = document.querySelector("form[action*='/cart/add']");
        if (form) {
          var hiddenQty = form.querySelector('input[name=\"quantity\"]');
          if (hiddenQty) hiddenQty.value = input.value;
        }
      });
    });

    // Cart page quantity (event delegation, bound only once)
    if (_cartQtyBound) return;
    _cartQtyBound = true;

    // +/- button clicks
    document.addEventListener("click", function (e) {
      var btn = e.target.closest(".cart-item__qty-btn");
      if (!btn) return;
      e.preventDefault();
      var container = btn.closest(".cart-item__quantity");
      if (!container) return;
      var input = container.querySelector(".cart-item__qty-input");
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      var line = input.getAttribute("data-line");
      var action = btn.getAttribute("data-action");
      if (action === "increase") input.value = val + 1;
      else if (action === "decrease") {
        if (val <= 1) return;
        input.value = val - 1;
      }
      if (line) _debouncedCartUpdate(line, parseInt(input.value, 10));
    });

    // Direct input value changes (typing + Enter/blur)
    document.addEventListener("change", function (e) {
      var input = e.target.closest(".cart-item__qty-input");
      if (!input) return;
      var line = input.getAttribute("data-line");
      if (!line) return;
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 1) {
        input.value = 1;
        val = 1;
      }
      _debouncedCartUpdate(line, val);
    });
  }

  // Rate-limited debounced cart update (avoids triggering anti-bot challenges)
  var _cartDebounce = null;
  var _cartPending = null; // { line, quantity } — latest request to send

  function _debouncedCartUpdate(line, quantity) {
    _cartPending = { line: line, quantity: quantity };
    if (_cartDebounce) clearTimeout(_cartDebounce);
    _cartDebounce = setTimeout(function () {
      _cartDebounce = null;
      _sendCartUpdate();
    }, 800);
  }

  var _cartLastSent = 0;
  var _cartMinInterval = 2500; // minimum 2.5s between requests

  function _sendCartUpdate() {
    if (!_cartPending) return;
    var now = Date.now();
    if (now - _cartLastSent < _cartMinInterval) {
      // Still in cooldown — re-schedule one batch after it expires
      if (_cartDebounce) clearTimeout(_cartDebounce);
      _cartDebounce = setTimeout(
        function () {
          _cartDebounce = null;
          _sendCartUpdate();
        },
        _cartMinInterval - (now - _cartLastSent) + 200,
      );
      return;
    }
    _cartLastSent = now;
    var p = _cartPending;
    _cartPending = null;

    var sectionEl = document.querySelector(".cart-page");
    var sectionId = sectionEl ? sectionEl.getAttribute("data-id") : null;
    var sections = sectionId ? [sectionId] : [];

    var body = JSON.stringify({
      line: p.line,
      quantity: p.quantity,
      sections: sections,
      sections_url: window.location.pathname,
    });

    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: body,
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var updated = false;

        if (sectionId && data.sections && data.sections[sectionId]) {
          var html = data.sections[sectionId];
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var newHeader = doc.querySelector(".cart-page__header");
          var newItems = doc.querySelector(".cart-page__items-card");
          var newSummary = doc.querySelector(".cart-page__summary-card");

          if (newHeader && sectionEl) {
            var oldHeader = sectionEl.querySelector(".cart-page__header");
            if (oldHeader) oldHeader.innerHTML = newHeader.innerHTML;
          }
          if (newItems) {
            var oldItems = document.querySelector(".cart-page__items-card");
            if (oldItems) {
              oldItems.innerHTML = newItems.innerHTML;
              updated = true;
            }
          }
          if (newSummary) {
            var oldSummary = document.querySelector(".cart-page__summary-card");
            if (oldSummary) {
              oldSummary.innerHTML = newSummary.innerHTML;
              updated = true;
            }
          }
        }

        if (!updated && data.items) {
          function fmtPrice(c) {
            return window.Shopify && Shopify.formatMoney
              ? Shopify.formatMoney(c)
              : "\u00a5" + (c / 100).toFixed(2);
          }
          data.items.forEach(function (item) {
            var el = document.querySelector(
              '.cart-item[data-line="' + (item.index + 1) + '"]',
            );
            if (!el) return;
            var p = el.querySelector(".cart-item__price-final");
            if (p) p.textContent = fmtPrice(item.final_line_price);
            var o = el.querySelector(".cart-item__price-original");
            if (o)
              o.style.display =
                item.original_line_price !== item.final_line_price
                  ? ""
                  : "none";
            var q = el.querySelector(".cart-item__qty-input");
            if (q) q.value = item.quantity;
          });
          if (data.total_price) {
            var t = document.querySelectorAll(".cart-page__summary-value");
            t.forEach(function (e) {
              e.textContent = fmtPrice(data.total_price);
            });
          }
          if (data.item_count !== undefined) {
            var c = document.querySelector(".cart-page__count");
            if (c)
              c.textContent =
                data.item_count +
                " " +
                (data.item_count === 1 ? "item" : "items");
          }
          updated = true;
        }

        if (!updated) location.reload();
        if (data.item_count === 0) location.reload();
      })
      .catch(function () {
        location.reload();
      });
  }

  // Cart item remove button (old custom cart only; Dawn cart uses native cart.js)
  function initCartRemoveButtons() {
    document.addEventListener("click", function (e) {
      // Skip if Dawn's <cart-items> is on this page
      if (document.querySelector("cart-items")) return;

      var btn = e.target.closest(".cart-item__remove");
      if (!btn) return;
      var line = btn.getAttribute("data-line");
      if (line) {
        _cartPending = { line: line, quantity: 0 };
        if (_cartDebounce) clearTimeout(_cartDebounce);
        _cartDebounce = null;
        _sendCartUpdate();
      }
    });
  }

  // ============================================================
  // Initialize Everything
  // ============================================================
  function init() {
    initHeaderScroll();
    initMobileMenu();
    initFadeInObserver();
    initProductCatalogTabs();
    initProductsPage();
    initProductInfo();
    initQuantitySelectors();
    initCartRemoveButtons();
    initImageFallback();
    initAnchorNav();
    initActiveNav();
  }

  // Run on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
